import { Component } from '@theme/component';

class EqPdpTabs extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#selectHashTab();
  }

  selectTab(event) {
    const button = event.target;
    if (!(button instanceof HTMLButtonElement)) return;
    this.#activate(button, true);
  }

  handleKeydown(event) {
    const button = event.target;
    if (!(button instanceof HTMLButtonElement)) return;

    const tabs = this.refs.tabs ?? [];
    const index = tabs.indexOf(button);
    if (index < 0) return;

    let nextIndex = index;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = tabs.length - 1;
    else return;

    event.preventDefault();
    const next = tabs[nextIndex];
    next?.focus();
    if (next instanceof HTMLButtonElement) this.#activate(next, true);
  }

  #selectHashTab() {
    const hash = window.location.hash.replace(/^#/, '');
    if (!hash) return;
    const tab = (this.refs.tabs ?? []).find((candidate) => candidate.dataset.tabId === hash);
    if (tab instanceof HTMLButtonElement) this.#activate(tab, false);
  }

  #activate(activeTab, updateUrl) {
    const targetId = activeTab.dataset.tabId;
    if (!targetId) return;

    for (const tab of this.refs.tabs ?? []) {
      const selected = tab === activeTab;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    }

    for (const panel of this.refs.panels ?? []) {
      const selected = panel.dataset.panelId === targetId;
      panel.classList.toggle('is-active', selected);
      panel.hidden = !selected;
    }

    if (updateUrl) {
      history.pushState(null, '', `#${targetId}`);
    }
  }
}

if (!customElements.get('eq-pdp-tabs')) {
  customElements.define('eq-pdp-tabs', EqPdpTabs);
}
